module.exports = __webpack_public_path__ + "static/mobile-8fdf9c255f08af824ff2da97e90ebe57.png";